
export const SET_DOCTOR_PERSONA = "SET_DOCTOR_PERSONA";
export const LOGOUT = "CLEAR_COMMON_STATE";
export const STORE_SEARCH_VALUE = "STORE_SEARCH_VALUE";

